import {GET, POST} from "@/services/gateway";

const list = ({pagination, search, filter, orgUnitPath}) => {

  return POST('google/user/list', {pagination, search, filter, orgUnitPath});
}

const listOrganizationlUnits = () => {
  return GET('google/user/org-units');
}

const getStatus = () => {
  return GET('google/user/status');
}

const getStatusOrgUnits = ({ orgUnitPath }) => {
  return POST('google/user/status', { orgUnitPath });
}

const refresh = () => {
  return GET('google/user/refresh');
}

const backupAll = () => {
  return GET('google/user/backup/all')
}

const backupAllActiveSeats = (orgUnitPath) => {
  const param = orgUnitPath ? `?orgUnitPath=${orgUnitPath}` : '';
  return GET(`google/user/backup/active-seats${param}`);
}

const protectAll = ({ orgUnitPath }) => {
  return POST('google/user/protect', { orgUnitPath });
}
 const unprotectAll = ({ orgUnitPath }) => {
  return POST('google/user/unprotect', { orgUnitPath });
}
const changeStatus = ({status, id}) => {
  return POST('google/user/userstatus/change', {status, id});
}

const exportSnapshot = (filter, search, pagination) => {
  const currentDate = new Date();

  return POST('google/user/export', {filter, search, pagination, TimeZoneOffset: currentDate.getTimezoneOffset()})
}

export {
  list,
  listOrganizationlUnits,
  refresh,
  getStatus,
  protectAll,
  unprotectAll,
  backupAllActiveSeats,
  backupAll,
  changeStatus,
  exportSnapshot,
  getStatusOrgUnits
}
